import { render, staticRenderFns } from "./Pins.vue?vue&type=template&id=80c9a506&"
import script from "./Pins.vue?vue&type=script&lang=js&"
export * from "./Pins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports